import { ENTER } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, Output, OnInit, NO_ERRORS_SCHEMA } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { Subject, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { CommonModelService } from '../../../../../padu-reporting/capability/common-model.service';
import { MaintenanceService } from '../../../../../techopsv4/services/maintenanceService';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatSelect, MatOption } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatAutocompleteTrigger, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInput, MatChipGrid, MatChipRow, MatChipRemove } from '@angular/material/chips';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'app-add-edit-forecast-service',
    templateUrl: './add-edit-forecast-service.component.html',
    styleUrl: './add-edit-forecast-service.component.css',
    imports: [FormsModule, MatFormField, MatSelect, MatOption, MatInput, MatAutocompleteTrigger, MatChipInput, NgClass, MatAutocomplete, MatChipGrid, MatChipRow, MatIcon, MatChipRemove],
    schemas: [NO_ERRORS_SCHEMA],
})
export class AddEditForecastServiceComponent implements OnInit {

  PVCloud:string;
  isInValidData =true
  @Input() isEdit: boolean = false;
  @Input() category: any = [];
  @Input() editData = null;
  @Input() publicPrivate: any = [];
  selectedAddUserslist: any = [];
  selectedRemoveUserlist: any = [];
  deletionUserList: any = [];
  statusUpdatedUsers: any = [];
  searchUserList: any = [];
  searchUser: any;
  dataSourceDetails: MatTableDataSource<any>;
  isTableRefreshed: boolean = false;
  @Output() updateSerivceTable = new EventEmitter();
  @Output() getLatestChanges: EventEmitter<any> = new EventEmitter();
  subject = new Subject<string>();
  DATA_SCHEMA = {
    org_name: 'text',
    isEdit: 'isEdit'
  };
  sortConfig = {
    active: 'Full_Name',
    direction: 'asc'
  };
  separatorKeysCodes: number[] = [ENTER];
  uniqueCategory:any[]=[];
  uniquePublicPrivate:any[]=[];
  editTohData = ["Yes","No"]
  categoryForm:string;
  editToh:string;
  srvDisabled:string;
  externalLink:string;
  nameArray:string[]=[]
  emailArray:string[]=[]
  msidArray:string[]=[]
  isAnyChange: boolean = false;
  oldMsidArray: string[] = [];
  UI_Comments: string;
  constructor(private toasterService: ToastrService,private toaster: ToastrService,public maintenanceService: MaintenanceService, private capabilityService: CommonModelService) { }
//set the initial data
setInitialData() {
  this.selectedAddUserslist = [];
  this.selectedRemoveUserlist = [];
  this.deletionUserList = [];
  this.statusUpdatedUsers = [];
  this.searchUserList = [];
  this.searchUser = null;
  this.UI_Comments = '';
}

ngOnInit(): void {
if(this.editData.Service_Owner_Name){
  this.nameArray = this.editData?.Service_Owner_Name.split(';').map(name=>name.trim())
  this.emailArray = this.editData?.Service_Owner_Email.split(',').map(name=>name.trim())
  this.msidArray = this.editData?.Service_Owner_msid.split(',').map(name=>name.trim())
  this.oldMsidArray = [...this.msidArray];
}
  this.initialiaseData();//for every change in the input data, re-initialize the dataa
  this.uniqueCategory=[...new Set(this.category)]
  this.uniquePublicPrivate=[...new Set(this.publicPrivate)]
  this.PVCloud = this.editData?.Public_Private_Cloud;
  this.categoryForm = this.editData?.Category;
  this.editToh = this.editData?.Edit_TOH;
  this.srvDisabled = this.editData.SRV_Disable;
  this.externalLink = this.editData?.External_Link;
  this.UI_Comments =  this.editData?.UI_Comments || '';
}

initialiaseData() {

  this.setInitialData();//set the initial data
  this.setUpSubject();//Set up the subject for the search user 

}



//Function to set up the subject for the search user
setUpSubject() {
  this.subject.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => this.getSearchedUser().pipe(
      catchError(() => {
        this.toasterService.error('Failed to load LDAP users', '', { timeOut: 10000, positionClass: 'toast-top-center' });
        return of([]);
      })
    ))
  ).subscribe((users) => {
    this.searchUserList = users;
  },
    () => {
      // Handle error scenario
      this.toasterService.error('Failed to load LDAP users', '', { timeOut: 10000, positionClass: 'toast-top-center' });
    });
}



//map the selected added user with leadEA and isNewUser
mapSelectedAddedUser() {
  this.selectedAddUserslist.forEach((user: any) => {
    user['leadEA'] = 'No';
    user['isNewUser'] = true;
  });
}



//Function to clear the data after adding the user
clearDataForAddUser() {
  this.selectedAddUserslist = [];
  this.searchUserList = [];
  this.searchUser = null;
  this.isTableRefreshed = true;
  this.getUpdatedValues();
}

//Function to check if the new added user is already present in the existing list
//If yes then replace the data with the existing data
replaceDataForExistingtUser(arr1, arr2, key) {
    const replaceDataArray = [...arr1];
    arr2.forEach((item2) => {
      const index = replaceDataArray.findIndex((item) => item[key] === item2[key]);
      if (index > -1) {
        this.deletionUserList = this.removeUserFromList(this.deletionUserList, replaceDataArray[index], 'mail');
        replaceDataArray[index] = item2;
      } else {
        replaceDataArray.push(item2);
      }
    });
    return replaceDataArray;
  }

//Function to remove user from the list
removeUserFromList(arr1,obj, key) {
  return arr1.filter((item) => item[key] != obj[key]);
}



//Function to check when the user is removed from the list then is the user lead status also updated
//If yes then remove the user from the statusUpdatedUsers list
checkUserForLeadEA(arr1, arr2, key) {
  arr2.forEach((item) => {
    const index = arr1.findIndex((user: any) => user[key] == item[key]);
    if (index > -1) {
      arr1.splice(index, 1);
    }
  });
  return arr1;
}

//Function to create data source for the table
createDataSource(data) {
  this.dataSourceDetails = new MatTableDataSource(data);
}

//Function to handle checkbox click event
checkboxClick(event) {
  this.selectedRemoveUserlist = event.data;
  if (this.isTableRefreshed) {
    this.isTableRefreshed = false;
  }
}

//Function to filter the array based on the key
filterArray(array1, array2, key1) {
  {
    const array2Ids = array2.map((item) => {
      return item[key1]
    });
    array1 = array1.filter(item => {
      if (!array2Ids.includes(item[key1])) {
        return item;
      }
    });

    return array1;
  }
}

//Function to pass the updated values to the parent component
getUpdatedValues() {
  const updatedValues = {
    removeUsers: this.deletionUserList,
    statusUpdatedUsers: this.statusUpdatedUsers,
    addUsers: this.dataSourceDetails.data.filter((user: any) => user.isNewUser)
  }
  this.getLatestChanges.emit(updatedValues);
}

filterUsers(arr, key) {
  return arr.filter((user: any) => !user[key]);
}

// Load User data into the table
public onSearchUser(ev) {
  this.searchUser = ev;
  if (this.searchUser.target.value.length >= 4) {
    this.subject.next(this.searchUser.target.value);
  }
}

// Get the searched user from the LDAP API
getSearchedUser() {
  return this.capabilityService.getLDAPUsers(this.searchUser.target.value);
}

//Function to get the selected users
//Also checks if the user is selected/deselected
getSelectedUsers(event) {
  const email= event.option.value.mail || '';
  const msid = event.option.value.MSId || event.option.value.cn;
  const name = event.option.value.displayName || '';
  this.nameArray.push(name);
  this.emailArray.push(email);
  this.msidArray.push(msid);
  const userDatA = event.option.value;
  userDatA['MSId'] = userDatA['cn'];
  this.selectedAddUserslist.push(userDatA)
  this.searchUser.target.value = '';
  this.searchUserList = [];
  if(this.isTableRefreshed){
    this.isTableRefreshed = false;
  }
  this.checkForChanges();
}

//check if the user is already present in the list
//if yes the delete the user from the list
removeUserData:any[]=[];
removeSelectedUser(index) {
 if(index !== -1){
  this.removeUserData.push({
    "Service_Owner_msid":this.msidArray?.[index]?.trim() || "",
    "Service_Owner_Name":this.nameArray?.[index]?.trim() || "",
    "Service_Owner_Email":this.emailArray[index]?.trim() || "",
  });
  this.nameArray.splice(index,1);
  this.msidArray.splice(index,1);
  this.emailArray.splice(index,1)

 }
  this.searchUserList = [];
  this.checkForChanges();
}

updateForecast() {
   const maxLength = Math.max(this.nameArray.length,this.emailArray.length,this.msidArray.length);
  const userData = Array.from({length:maxLength},(_,index)=>({
    "Service_Owner_msid":this.msidArray?.[index]?.trim() || "",
    "Service_Owner_Name":this.nameArray?.[index]?.trim() || "",
    "Service_Owner_Email":this.emailArray[index]?.trim() || "",
  }))

  const payload = {
    "id": this.editData.id,
        "Service":this.editData.Service,
        "Category":this.categoryForm,
        "SRV_Disable": this.srvDisabled === 'Yes' ? "Disable" : "" ,
        "Edit_TOH":this.editToh,
        "Public_Private_Cloud":this.PVCloud,
        "External_Link" : this.externalLink,
            "add_SO" : userData,
            "remove_SO":this.removeUserData,
            "UI_Comments": this.UI_Comments
}
  this.maintenanceService.updateForecastServiceMapping(payload).subscribe(
    (res: Array<any>) => {
      if (res) {
        this.updateSerivceTable.emit('Success');
        this.toaster.success('Successfully Updated.', '', {
          timeOut: 5000,
          positionClass: 'toast-top-center'
        });
      }
    },
    error => {
      // console.error('Error updating forecast master:', error);
      console.log(error)
      this.toaster.error('Failed to update forecast master', '', {
        timeOut: 5000,
        positionClass: 'toast-top-center'
      });
    }
  );
}

checkForChanges() {
  this.isAnyChange = false;
  if (this.PVCloud !== this.editData?.Public_Private_Cloud ||
      this.categoryForm !== this.editData?.Category ||
      this.editToh !== this.editData?.Edit_TOH ||
      this.srvDisabled  !== this.editData.SRV_Disable ||
      this.UI_Comments !== (this.editData?.UI_Comments == null ? '' : this.editData?.UI_Comments) ||
      (this.editData?.External_Link == null && !(this.externalLink == '' || this.externalLink == null)) ||
      (this.editData?.External_Link != null && this.externalLink !== this.editData?.External_Link) ||
      this.checkUserChange()
      
    ) {
    this.isAnyChange = true;
  }
}
checkUserChange() {
  if(this.msidArray.length !== this.oldMsidArray.length) {
    return true;
  }else {
    if(this.msidArray.length > 0 && this.oldMsidArray.length > 0) {
      // const sortedNewMsidArray = [...this.msidArray].sort().join(',');
      // const sortedOldMsidArray = [...this.oldMsidArray].sort().join(',');
      const sortedNewMsidArray = [...this.msidArray].sort((a, b) => a.localeCompare(b)).join(',');
      const sortedOldMsidArray = [...this.oldMsidArray].sort((a, b) => a.localeCompare(b)).join(',');      
      if (sortedNewMsidArray !== sortedOldMsidArray) {
        return true;
      }
    }
  }
  return false;
}

editTohChanged(){
  if(this.editToh == 'Yes'){
    this.srvDisabled = 'No';
  }
  this.checkForChanges();
}

}
